var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1741_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 13C7.53358 13 7.13358 12.8 6.86691 12.4667L0.266908 5.06668C-0.133092 4.53335 -0.0664248 3.73335 0.466909 3.33335C1.00024 2.93335 1.73358 2.93335 2.13358 3.46668L7.86691 10C7.93358 10.0667 8.00024 10.0667 8.13358 10L13.8669 3.46668C14.3336 2.93335 15.0669 2.86668 15.6002 3.33335C16.1336 3.80001 16.2002 4.53335 15.7336 5.06668L15.6669 5.13335L9.13358 12.5333C8.86691 12.8 8.40024 13 8.00024 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1741_2097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic_arrow_down.41404e2b757ccaaf6abf175942626967.svg";
export { ForwardRef as ReactComponent };